export default __webpack_public_path__ + "locales/ar-SA/Common.json?hash=2f280e286050578fa27034b14fecacbb";